import { createAction, props } from '@ngrx/store';

export const updateConfiguration = createAction(
  '[Logger] Update Configuration',
  props<{
    payload: {
      appName?: string;
      securityCode?: string;
      version?: string;
    };
  }>()
);
